module.exports = __webpack_public_path__ + "static/media/people.f68e5632.svg";